module.exports = "/static/assets/b6a3c548c7991639567e6ff5a26ae10c.png";